export const parseSeconds = (totalSeconds: number | string) => {
    const totalSecondsAsNumb = Number(totalSeconds);
    const minutes = Math.floor(totalSecondsAsNumb / 60);
    const seconds = Math.round(totalSecondsAsNumb % 60);
    return `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
};
